import { render, staticRenderFns } from "./install.vue?vue&type=template&id=cbf0b7e0"
import script from "./install.vue?vue&type=script&lang=js"
export * from "./install.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports